import cx from 'classnames'
import { FC } from 'react'

import Button from 'src/components/ui/atoms/Button'
import useHasChangeOnPage from 'src/hooks/useHasChangeOnPage'
import useTracking from 'src/hooks/useTracking'
import useUpdateDashboard from 'src/hooks/useUpdateDashboard'
import { useAppSelector } from 'src/redux/hooks'
import SaveIcon from '../../atoms/Icons/SaveIcon'

import * as styles from './PageHeader.scss'

const PageHeaderSaveDashboard: FC = () => {
  const { trackEvent } = useTracking()
  const isLoadingDone = useAppSelector(state =>
    state.root.loadingComponents.every(component => !component.loading),
  )
  const { handleUpdateDashboard } = useUpdateDashboard()
  const { hasChangesOnDashboard } = useHasChangeOnPage()

  return (
    <Button
      buttonType={!isLoadingDone || !hasChangesOnDashboard ? 'disable' : 'silence'}
      onClick={() => {
        handleUpdateDashboard()
        trackEvent({ action: 'Click: Save Dashboard' })
      }}
      className={cx(styles.PageHeaderIcon, 'gap-2 !bg-transparent !p-0')}
    >
      <SaveIcon />
      <span className="text-sm font-medium">Save</span>
    </Button>
  )
}

export default PageHeaderSaveDashboard
